import { CaseMetadata } from '../components/CaseMetadata';
import { useSettingsContext } from '../context/SettingsContext';

export const CaseMetadataRoute = () => {
  const { caseId, caseName, createdDate, createdBy } = useSettingsContext();

  return <CaseMetadata caseId={caseId} caseName={caseName} createdDate={createdDate} createdBy={createdBy} />;
};
